<template>
    <div>
        <base-header class="pb-6">
            <b-row align-v="center" class="py-3">
                <b-col cols="6">
                    <h2 class="listing-title d-inline-block mb-0">Notifications</h2>
                </b-col>
            </b-row>
        </base-header>
        <b-container fluid class="mt--6">
            <NotificationTable></NotificationTable>
        </b-container>
    </div>
</template>

<script>
import { Tabs, TabPane } from 'element-ui'
import RouteBreadCrumb from '@/components/Breadcrumb/RouteBreadcrumb'
import NotificationTable from './NotificationTable.vue';

export default {
    components: {
    RouteBreadCrumb,
    [Tabs.name]: Tabs,
    [TabPane.name]: TabPane,
    NotificationTable
},
    data() {
        return {
            backButton: false,
        };
    },
    methods: {
  
    }
}
</script>